import environment from '../../../common/environment';
import { CustomISBN } from '../interfaces/custom-isbn.interface';
import { getResponseData } from '../../../common/utils/api-utils';

/*----- HELPERS -----*/
export async function getCustomISBNSearchApiCall(isbn): Promise<CustomISBN> {
  const url = `${environment().searchServiceUrl}/directdistribution/isbn/${isbn}`;
  return await getResponseData(
    new Request(url.toString(), {
      method: 'GET',
      headers: {'Content-Type': 'application/json'}
    })
  );
}
